import React, { useCallback } from 'react';

import * as fromProjects from 'store/Projects';

import * as fromProjectTitleSections from 'components/Project/ProjectTitleSections/Index';

export interface ITitleComponentOptionalProps {
  sticky: boolean;
  verticallyCentred: boolean;
}

interface IProps {
  animateIn: boolean;
  contentSection: fromProjects.IContentSection;
  contentBlock: fromProjects.IContentBlock;
  titleComponentOptionalProps: ITitleComponentOptionalProps;
}

export const ProjectTitleBlock: React.FC<IProps> = ({ animateIn, contentSection, contentBlock, titleComponentOptionalProps, ...props }) => {
  const getTitleComponent = useCallback(() => {
    const componentName = contentBlock.titleSection.type;
    let componentVariation = contentBlock.titleSection.titleContent.variation;

    const titleComponentCommonProps = {
      titleContent: contentBlock.titleSection.titleContent,
      animateIn,
    };

    if (componentName === 'default') {
      return <fromProjectTitleSections.Default {...titleComponentCommonProps} contentSection={contentSection} sticky={titleComponentOptionalProps.sticky} verticallyCentred={titleComponentOptionalProps.verticallyCentred} />;
    } else if (componentName === 'threeColumn') {
      componentVariation = componentVariation as fromProjects.IContentTitleThreeColumnVariations;
      if (componentVariation === 'default')
        return <fromProjectTitleSections.ThreeColumn.Default {...titleComponentCommonProps} />;
      else if (componentVariation === 'inlineTitle')
        return <fromProjectTitleSections.ThreeColumn.InlineTitle {...titleComponentCommonProps} />;
    } else {
      return null;
    }
  }, [animateIn]);

  if (contentBlock.titleSection != null) {

    return getTitleComponent();
  } else
    return null;
};
